export default __webpack_public_path__ + "static/media/ThumbUpIcon.2f4dae2c.svg";